import React from "react";
import PortraitProgramLayout from "./PortraitProgramLayout";
import { useAuthContext } from "../../context/auth";
import { getMinute, getTimeToKo } from "../../utils/getMinute";

function PartInfo({ isPart1 }: { isPart1: boolean }) {
  const { circuitProgram } = useAuthContext();
  if (!circuitProgram) {
    return null;
  }
  return (
    <PortraitProgramLayout>
      <div className="w-full h-full flex justify-center items-center">
        <div className="flex flex-col gap-[120px] items-center">
          <h1 className="gradient-text text-[60px] font-extrabold">
            PART {isPart1 ? 1 : 2}
          </h1>
          <div className="flex flex-col gap-[60px] items-center">
            <div className="flex flex-col gap-[10px] items-center">
              <h3 className="text-[60px] font-bold text-white leading-[90px]">
                동작 시간
              </h3>
              <h1 className="text-[120px] leading-[140px] font-extrabold gradient-text">
                {getTimeToKo(getMinute(circuitProgram.part1.time))}
              </h1>
            </div>
            <div className="w-[220px] h-[6px] bg-[#463C2D]" />
            <div className="flex flex-col gap-[10px] items-center">
              <h3 className="text-[60px] font-bold text-white leading-[90px]">
                쉬는 시간
              </h3>
              <h1 className="text-[120px] leading-[140px] font-extrabold gradient-text">
                {getTimeToKo(getMinute(circuitProgram.part1.restTime))}
              </h1>
            </div>
            <div className="w-[220px] h-[6px] bg-[#463C2D]" />
            <div className="flex flex-col gap-[10px] items-center">
              <h3 className="text-[60px] font-bold text-white leading-[90px]">
                반복 횟수
              </h3>
              <h1 className="text-[120px] leading-[140px] font-extrabold gradient-text">
                {circuitProgram.part1.repeatCount} 회
              </h1>
            </div>
          </div>
        </div>
      </div>
    </PortraitProgramLayout>
  );
}

export default PartInfo;
